import React, { useState, useRef, useCallback, useEffect } from "react";
import styled from "styled-components";
import axios from "axios";
import {
  TextInput,
  DropdownSingle,
} from "oolib";
import AudioInput from "@/components/inputs/AudioInput";
import { ButtonPrimary } from "oolib/dist/v2/components/Buttons";
import {
  InterfaceContainer,
  InterfaceHeader,
  InterfaceDescription,
  InterfaceActions,
  HelpText,
} from "./BaseIntegrationInterface";

// ============================================
// SARVAM ICON
// ============================================

export const SarvamIcon = ({ size = 32 }) => (
  <svg
    width={size}
    height={Math.round((size * 28) / 101)}
    viewBox="0 0 101 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M28.3664 6.51095L28.3103 8.84328L28.2978 9.26111L28.092 8.89941C27.5889 8.00763 26.8946 7.31542 26.0257 6.83107C25.1755 6.34881 24.2152 6.10352 23.1696 6.10352C21.8516 6.10352 20.6418 6.45898 19.5775 7.15328C18.509 7.85381 17.6422 8.81002 16.9999 9.99698C16.3804 11.1819 16.0645 12.5538 16.0645 14.0713C16.0645 15.5888 16.3596 16.9379 16.9438 18.1248C17.5258 19.2889 18.3427 20.2243 19.3696 20.9041C20.4132 21.561 21.6126 21.8956 22.9305 21.8956C25.2732 21.8956 27.009 20.9561 28.0941 19.0997L28.2978 18.7505L28.3103 19.1559L28.3664 21.4757H31.736V6.51095H28.3664ZM27.2127 17.4472C26.3999 18.341 25.3314 18.7921 24.0364 18.7921C22.7413 18.7921 21.6646 18.341 20.831 17.4492C20.0099 16.5471 19.6108 15.4225 19.6108 14.0131C19.6108 12.6037 20.0224 11.4438 20.831 10.5769C21.6625 9.68517 22.7413 9.23201 24.0364 9.23201C25.3314 9.23201 26.3999 9.68517 27.2127 10.5769C28.0213 11.4459 28.4308 12.6016 28.4308 14.0131C28.4308 15.4245 28.0213 16.5595 27.2127 17.4472Z" fill="black"/>
    <path d="M43.4293 6.56213L43.1237 9.86316C42.5396 9.65736 41.9388 9.54927 41.338 9.54927C40.1261 9.54927 39.1782 10.0004 38.5193 10.8838C37.8666 11.7382 37.5381 12.9709 37.5381 14.5486V21.4729H33.998V6.5164H37.3905L37.4176 9.4287L37.4238 10.0669L37.6421 9.46612C38.0121 8.45585 38.5609 7.66594 39.2822 7.12339C39.9973 6.56421 40.8392 6.27734 41.7871 6.27734C42.0989 6.27734 42.4148 6.30852 42.7246 6.36465C43.0135 6.41662 43.2484 6.48314 43.4313 6.56213H43.4293Z" fill="black"/>
    <path d="M59.8445 6.52344L53.9762 21.4758H50.2199L44.3496 6.52344H48.3262L52.1178 17.8359L52.1719 17.998L52.2259 17.8359L56.109 6.52344H59.8445Z" fill="black"/>
    <path d="M71.9509 6.51082L71.8844 8.84524L71.876 9.26306L71.6702 8.90136C71.1651 8.00959 70.4708 7.31737 69.604 6.83302C68.7538 6.35076 67.7934 6.10547 66.7478 6.10547C65.4278 6.10547 64.2201 6.46093 63.1558 7.15523C62.0873 7.85576 61.2184 8.81198 60.5781 9.99893C59.9566 11.1838 59.6406 12.5558 59.6406 14.0732C59.6406 15.5907 59.9379 16.9419 60.5199 18.1268C61.102 19.2909 61.921 20.2263 62.9479 20.906C63.9914 21.5629 65.1888 21.8976 66.5088 21.8976C68.8494 21.8976 70.5872 20.958 71.6682 19.1017L71.874 18.7525L71.8823 19.1578L71.9426 21.4777H75.3101L75.3163 6.51498H71.9488L71.9509 6.51082ZM70.7847 17.447C69.974 18.3409 68.9055 18.792 67.6084 18.792C66.3113 18.792 65.2366 18.3409 64.403 17.4491C63.5819 16.5469 63.1849 15.4223 63.1849 14.013C63.1849 12.6036 63.5944 11.4437 64.403 10.5768C65.2345 9.68505 66.3134 9.23188 67.6084 9.23188C68.9035 9.23188 69.974 9.68505 70.7847 10.5768C71.5933 11.4457 72.0028 12.6015 72.0028 14.013C72.0028 15.4244 71.5933 16.5594 70.7847 17.447Z" fill="black"/>
    <path d="M100.883 12.4291V21.4737H97.3575V13.1172C97.3575 10.5271 96.3451 9.2133 94.3475 9.2133C93.2831 9.2133 92.4392 9.58955 91.8405 10.3296C91.2688 11.0447 90.9799 12.0736 90.9799 13.3874V21.4757H87.4814V13.0881C87.4814 10.5167 86.4795 9.2133 84.5026 9.2133C83.4362 9.2133 82.5922 9.58955 81.9956 10.3296C81.4032 11.0426 81.1059 12.0716 81.1059 13.3874V21.4757H77.6074V6.51303H80.9895L81.0165 8.70401L81.0228 9.19043L81.2348 8.7539C81.6402 7.92448 82.2472 7.26761 83.0391 6.80405C83.8353 6.33841 84.7666 6.10352 85.8143 6.10352C88.0593 6.10352 89.6079 7.09299 90.4207 9.04492L90.5247 9.29229L90.6328 9.04908C91.0402 8.13859 91.6867 7.41312 92.5577 6.89136C93.4287 6.36544 94.4223 6.10352 95.5115 6.10352C97.239 6.10352 98.5735 6.6523 99.4819 7.73324C100.411 8.79963 100.883 10.3815 100.883 12.4291Z" fill="black"/>
    <path d="M14.9814 17.0173C14.9814 18.805 14.152 20.1478 12.516 21.0043C10.9466 21.8275 9.02585 22 7.68923 22C5.09913 22 3.13057 21.5053 1.83968 20.5283C0.642328 19.6219 0.0249448 18.3082 0.00207873 16.6244V16.5724L0 16.4685H3.6752L3.67936 16.5683V16.6161C3.75835 18.3851 5.21762 19.36 7.79317 19.36C8.84916 19.36 11.3021 19.1625 11.3021 17.3312C11.3021 15.8532 9.30025 15.5746 6.98454 15.2483C3.87683 14.8138 0.355463 14.3191 0.355463 10.7541C0.355463 7.73366 2.80213 6 7.06561 6C11.6263 6 14.1894 7.68169 14.4825 10.8642L14.4867 10.9204L14.4971 11.0347H10.8156L10.8073 10.9391L10.8032 10.8933C10.7034 9.80408 9.70768 8.63999 7.21112 8.63999C5.0825 8.63999 3.91217 9.30934 3.91217 10.5254C3.91217 11.8787 5.84747 12.1156 8.09042 12.3921C9.62245 12.5792 11.3582 12.7933 12.6823 13.419C14.2289 14.1507 14.9814 15.3293 14.9814 17.0173Z" fill="black"/>
  </svg>
);

// ============================================
// LANGUAGE OPTIONS
// ============================================

const LANGUAGE_OPTIONS = [
  { display: "Auto-detect", value: "unknown" },
  { display: "Hindi", value: "hi-IN" },
  { display: "Bengali", value: "bn-IN" },
  { display: "Kannada", value: "kn-IN" },
  { display: "Malayalam", value: "ml-IN" },
  { display: "Marathi", value: "mr-IN" },
  { display: "Odia", value: "od-IN" },
  { display: "Punjabi", value: "pa-IN" },
  { display: "Tamil", value: "ta-IN" },
  { display: "Telugu", value: "te-IN" },
  { display: "English (Indian)", value: "en-IN" },
  { display: "Gujarati", value: "gu-IN" },
];

// ============================================
// BATCH STATUS LABELS
// ============================================

const BATCH_STATUS_LABELS = {
  initiating: "Starting transcription job...",
  Accepted: "Job accepted, preparing...",
  Pending: "Waiting in queue...",
  Running: "Transcribing audio...",
  completing: "Fetching results...",
};

// ============================================
// STYLED COMPONENTS
// ============================================

const FieldGroup = styled.div`
  margin-top: 16px;
`;

const ProgressContainer = styled.div`
  margin-top: 24px;
  text-align: center;
`;

const ProgressBarOuter = styled.div`
  width: 100%;
  height: 8px;
  background: ${({ theme }) => theme?.colors?.lightGrey || "#e0e0e0"};
  border-radius: 4px;
  margin-top: 12px;
  overflow: hidden;
`;

const ProgressBarInner = styled.div`
  height: 100%;
  background: ${({ theme }) => theme?.colors?.primaryColor || "#4A90D9"};
  border-radius: 4px;
  transition: width 0.5s ease;
  width: ${({ progress }) => progress}%;
`;

const StatusText = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme?.colors?.greyColor60 || "#666"};
  margin: 8px 0 0;
`;

const ProgressPercent = styled.p`
  font-size: 24px;
  font-weight: 600;
  margin: 0;
`;

// ============================================
// POLLING INTERVAL
// ============================================

const POLL_INTERVAL_MS = 3000;

// ============================================
// SARVAM INTERFACE
// ============================================

/**
 * SarvamInterface
 *
 * Batch transcription flow:
 * 1. Enter Sarvam API key
 * 2. Upload audio file
 * 3. Select language (optional)
 * 4. Click "Transcribe" -> initiates batch job -> polls for completion -> fetches results
 */
export const SarvamInterface = ({ adapterConfig, onSubmit, isLoading }) => {
  const [apiKey, setApiKey] = useState("");
  const [audioData, setAudioData] = useState([]);
  const [language, setLanguage] = useState(
    LANGUAGE_OPTIONS.find((o) => o.value === "unknown")
  );

  // Batch state
  const [batchState, setBatchState] = useState(null); // null | "initiating" | "polling" | "completing" | "error"
  const [batchJobId, setBatchJobId] = useState(null);
  const [batchProgress, setBatchProgress] = useState(0);
  const [batchStatusLabel, setBatchStatusLabel] = useState("");
  const [batchError, setBatchError] = useState(null);
  const pollIntervalRef = useRef(null);

  const audioUrl = audioData?.[0]?.publicUrl || "";
  const audioFilename = audioData?.[0]?.name || audioData?.[0]?.fileName || "audio";

  const canSubmit = apiKey.trim() && audioUrl;
  const isBatchInProgress = batchState && batchState !== "error";

  // Cleanup polling on unmount
  useEffect(() => {
    return () => {
      if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);
    };
  }, []);

  /**
   * Poll batch job status until completion or failure.
   * Supports dual jobs (transcribe + translate).
   */
  const startPolling = useCallback((transcribeId, translateId, key) => {
    const poll = async () => {
      try {
        const { data } = await axios.post("/api/externalImport/batch/status", {
          source: { id: "sarvam", apiKey: key },
          jobId: transcribeId,
          translateJobId: translateId,
        });

        setBatchProgress(data.progress || 0);
        setBatchStatusLabel(BATCH_STATUS_LABELS[data.status] || data.status);

        if (data.status === "Completed") {
          clearInterval(pollIntervalRef.current);
          pollIntervalRef.current = null;

          setBatchState("completing");
          setBatchStatusLabel(BATCH_STATUS_LABELS.completing);
          setBatchProgress(100);

          onSubmit({
            apiKey: key,
            adapterOptions: {
              audioUrl,
              audioFilename,
              languageCode: language?.value || "unknown",
              transcribeJobId: transcribeId,
              translateJobId: translateId,
            },
          });
        } else if (data.status === "Failed") {
          clearInterval(pollIntervalRef.current);
          pollIntervalRef.current = null;
          setBatchState("error");
          setBatchError(data.errorMessage || "Transcription job failed. Please try again.");
        }
      } catch (err) {
        clearInterval(pollIntervalRef.current);
        pollIntervalRef.current = null;
        setBatchState("error");
        setBatchError(err.response?.data?.error || err.message || "Failed to check job status");
      }
    };

    poll();
    pollIntervalRef.current = setInterval(poll, POLL_INTERVAL_MS);
  }, [audioUrl, audioFilename, language, onSubmit]);

  /**
   * Initiate dual batch jobs (transcribe + translate), then start polling.
   */
  const handleSubmit = useCallback(async () => {
    if (!canSubmit || isBatchInProgress) return;

    setBatchState("initiating");
    setBatchStatusLabel(BATCH_STATUS_LABELS.initiating);
    setBatchProgress(0);
    setBatchError(null);

    try {
      const trimmedKey = apiKey.trim();
      const { data } = await axios.post("/api/externalImport/batch/initiate", {
        source: {
          id: "sarvam",
          apiKey: trimmedKey,
          options: {
            audioUrl,
            audioFilename,
            languageCode: language?.value || "unknown",
          },
        },
      });

      if (!data.transcribeJobId || !data.translateJobId) {
        throw new Error("No job IDs returned from server");
      }

      setBatchJobId(data.transcribeJobId);
      setBatchState("polling");
      startPolling(data.transcribeJobId, data.translateJobId, trimmedKey);
    } catch (err) {
      setBatchState("error");
      setBatchError(
        err.response?.data?.error || err.message || "Failed to start transcription job"
      );
    }
  }, [canSubmit, isBatchInProgress, apiKey, audioUrl, audioFilename, language, startPolling]);

  /**
   * Reset batch state so user can retry.
   */
  const handleRetry = useCallback(() => {
    if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);
    setBatchState(null);
    setBatchJobId(null);
    setBatchProgress(0);
    setBatchStatusLabel("");
    setBatchError(null);
  }, []);

  return (
    <InterfaceContainer>
      <InterfaceHeader>Connect to Sarvam</InterfaceHeader>
      <InterfaceDescription>
        Transcribe audio files using Sarvam AI's Speech-to-Text. Upload an
        audio file and it will be transcribed and imported as data.
      </InterfaceDescription>

      <TextInput
        label="Sarvam API Key"
        placeholder="Enter your Sarvam API subscription key"
        value={apiKey}
        onChange={(k, v) => setApiKey(v)}
        type="password"
        readOnly={isBatchInProgress}
      />

      <HelpText>
        Find your API key in the Sarvam Dashboard.{" "}
        <a
          href="https://dashboard.sarvam.ai"
          target="_blank"
          rel="noopener noreferrer"
        >
          Open Dashboard
        </a>
      </HelpText>

      <FieldGroup>
        <AudioInput
          id="sarvam-audio"
          value={audioData}
          onChange={(id, newData) => setAudioData(newData)}
          readOnly={isBatchInProgress}
        />
      </FieldGroup>

      <FieldGroup>
        <DropdownSingle
          label="Audio Language"
          placeholder="Select language..."
          options={LANGUAGE_OPTIONS}
          value={language}
          onChange={(k, v) => setLanguage(v)}
          readOnly={isBatchInProgress}
          lightboxHeight="small"
          popOutOfOverflowHiddenParent={true}
        />
      </FieldGroup>

      {/* Batch progress UI */}
      {isBatchInProgress && (
        <ProgressContainer>
          <ProgressPercent>{batchProgress}%</ProgressPercent>
          <ProgressBarOuter>
            <ProgressBarInner progress={batchProgress} />
          </ProgressBarOuter>
          <StatusText>{batchStatusLabel}</StatusText>
        </ProgressContainer>
      )}

      {/* Error state with retry */}
      {batchState === "error" && (
        <ProgressContainer>
          <StatusText style={{ color: "red" }}>{batchError}</StatusText>
        </ProgressContainer>
      )}

      <InterfaceActions>
        {batchState === "error" ? (
          <ButtonPrimary onClick={handleRetry}>
            Try Again
          </ButtonPrimary>
        ) : (
          <ButtonPrimary
            onClick={handleSubmit}
            disabled={!canSubmit || isBatchInProgress || isLoading}
            isLoading={isBatchInProgress || isLoading}
          >
            Transcribe
          </ButtonPrimary>
        )}
      </InterfaceActions>
    </InterfaceContainer>
  );
};

// ============================================
// INTEGRATION META
// ============================================

export const sarvamIntegrationMeta = {
  id: "sarvam",
  name: "Sarvam",
  description: "Transcribe audio files using Sarvam AI Speech-to-Text",
};

export default SarvamInterface;
